module.exports = __webpack_public_path__ + "img/weblink.6e5fbf1a.svg";